import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/app/components/ui/accordion';
import { cn } from '@/app/utils';

type CustomAccordionProps = {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean; // 在 isUseAccordion = true 下使用是否默认展开
  isUseAccordion?: boolean; // 是否使用accordion组件
};

export const CustomAccordion = ({
  title,
  children,
  defaultExpanded = true,
  isUseAccordion = true,
}: CustomAccordionProps) => {
  return isUseAccordion ? (
    <Accordion type="single" collapsible defaultValue={defaultExpanded ? 'item-1' : undefined}>
      <AccordionItem value="item-1">
        <AccordionTrigger className={cn('cursor-default p-0 text-base text-system-white')}>{title}</AccordionTrigger>
        <AccordionContent className={cn(title && 'mt-3')}>{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  ) : (
    <div>
      {title && <div className="text-base text-system-white">{title}</div>}
      <div className={cn(title && 'mt-3')}>{children}</div>
    </div>
  );
};
